import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Answer, AnswerType } from '@wdx/clmi/clmi-swagger-gen';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { MAX_PAGINATION_PAGE_SIZE } from '../../constants/api.constants';
import { PaginatedApiResponse } from '@wdx/shared/utils';

@Injectable()
export class AnswersService {
    private apiPaginationService = inject(ApiPaginationService);
    private http = inject(HttpClient);
    private config = inject(ConfigService);

    getAnswerSetList(
        pageNumber = 1,
    ): Observable<PaginatedApiResponse<AnswerType>> {
        const headers = new HttpHeaders(
            this.apiPaginationService.mapPaginationOptions({
                pageNumber,
                pageSize: MAX_PAGINATION_PAGE_SIZE,
            }),
        );
        return this.http.post<PaginatedApiResponse<AnswerType>>(
            `${this.config.getConfiguration().API_BASE}/query/answertype`,
            {},
            { headers },
        );
    }

    disableAnswer(id: string, isDisabled: boolean): Observable<Answer> {
        return this.http.patch<Answer>(
            `${
                this.config.getConfiguration().API_BASE
            }/answer/${id}/disabled/${isDisabled}`,
            {},
        );
    }

    reorderAnswers(code: string, values: string[]): Observable<null> {
        return this.http.patch<null>(
            `${
                this.config.getConfiguration().API_BASE
            }/answertype/${code}/reorder`,
            values,
        );
    }
}
